import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { MdArrowBack } from 'react-icons/md'

export const NotFound = () => {
  return (
    <section className=' px-6 md:px-10 py-24 md:py-32 border-b border-ink/10 min-h-[72vh] flex items-center'>
      <div className=' max-w-7xl mx-auto w-full'>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className=' font-mono text-sm text-mint-deep mb-4'>
          (404 — Page not found)
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className=' font-display font-semibold text-maroon leading-[0.82] tracking-[-0.03em] text-[clamp(5rem,24vw,18rem)]'>
          4<span className=' italic font-normal text-mint-deep'>0</span>4
        </motion.h1>

        <div className=' grid md:grid-cols-12 gap-8 items-end border-t border-ink/10 pt-10 mt-10'>
          <p className=' md:col-span-6 text-lg md:text-2xl leading-relaxed text-ink/70 tracking-tight'>
            This page wandered off — the link may be broken, or the page may have moved.
          </p>
          <div className=' md:col-span-4 md:col-start-9 flex md:justify-end'>
            <Link
              to='/'
              className=' group inline-flex items-center gap-2 bg-maroon text-cream text-sm font-medium px-7 py-3.5 rounded-full transition-colors duration-300 hover:bg-mint hover:text-panel'>
              <MdArrowBack className=' text-lg transition-transform duration-300 group-hover:-translate-x-0.5' />
              Back home
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
